import SkeletonLoaderRow from 'components/loading/SkeletonLoaderRow';
import { useTranslation } from 'react-i18next';
import { Divider } from 'styles/CommonLayoutStyles';

const ParkingDetailSkeletonLoader = () => {
  const { t } = useTranslation();
  return (
    <>
      <SkeletonLoaderRow accessibilityLabel={t('account.parkingDetails')} />
      <Divider marginVertical={3} />
      <SkeletonLoaderRow accessibilityLabel={t('account.parkingDetails')} />
      <Divider marginVertical={3} />
      <SkeletonLoaderRow accessibilityLabel={t('account.parkingDetails')} />
    </>
  );
};

export default ParkingDetailSkeletonLoader;
